<template>
  <!--签署详情-->
  <el-container class="to-deatil_anony">
    <!-- 左侧文件预览 -->
    <el-aside width="2.80rem" class="aside-left" v-if="!hideAside">
      <div class="page-con">
        <p class="nav-tab">
          <span
            v-if="detailInfo.hideSignAllBtnFlag != 1"
            @click="navTab = 1"
            :class="navTab === 1 ? 'active' : ''"
            class="nav-item"
          >签署状态</span>
          <span @click="navTab = 2" :class="navTab === 2 ? 'active' : ''" class="nav-item">文件预览</span>
        </p>

        <div class="sec-content" :style="{ height: listHeight + 'px' }" v-show="navTab === 1">
          <div class="nav-item wnj">
            <label>文件名称</label>
            <p class="font-ellipsis" :title="detailInfo.contractName">{{ detailInfo.contractName }}</p>
          </div>
          <div class="nav-item wnj">
            <label>文件编号</label>
            <p class="font-ellipsis" :title="detailInfo.applyNo">{{ detailInfo.applyNo }}</p>
            <label>文件来源</label>
            <p class="font-ellipsis" :title="detailInfo.ebqUserName">名称：{{ detailInfo.ebqUserName }}</p>
          </div>
          <!--          <div class="nav-item"></div>-->
          <template v-for="(item, index) in detailInfo.signInfos">
            <div class="nav-item" :key="index">
              <label>
                签署方{{ index + 1 }}
                <span
                  v-if="item.signStatus == 1"
                  class="bar-status status-blue"
                >已签署</span>
                <span v-else-if="item.signStatus == 2" class="bar-status status-red">拒签</span>
                <span v-else class="bar-status status-orange">未签署</span>
              </label>
              <p>
                <template v-if="item.fullName">
                  名称：{{ item.fullName }}
                  <br />
                </template>
                证件号：
                <br />
                <template v-if="item.identityCardMask">
                  {{ item.identityCardMask }}
                  <br />
                </template>
                <template v-if="item.mobileMask">
                  {{ "接收手机：" + item.mobileMask }}
                  <br />
                </template>
                <template v-if="item.emailMask">
                  {{
                  "接收邮箱：" + item.emailMask
                  }}
                </template>
              </p>
            </div>
          </template>
        </div>

        <div class="list-pages" :style="{ height: listHeight + 'px' }" v-show="navTab === 2">
          <template v-for="i in convertInfo.items">
            <div
              @click="currentData = i"
              :class="currentData === i ? 'active' : ''"
              :key="i"
              class="list"
            >
              <img
                v-if="fileInfo.sign"
                :src="
                  apiMethods.FileOperController.convertDetail_url(
                    fileInfo.sign,
                    fileInfo.ts,
                    fileInfo.fileType,
                    'png',
                    fileInfo.targetId,
                    i,
                    convertInfo.docHash || ''
                  )
                "
              />
              <span class="p-index">{{ i }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="go-Page">
        <div>
          <div>
            <div class="bd">
              <el-input
                v-model="gotoPage"
                placeholder="输入页码"
                ref="contractPage"
                type="number"
                @keyup.enter.native="handleContractPageClick(gotoPage)"
              />
              /{{ convertInfo.items ? convertInfo.items : 0 }}
            </div>
            <a @click="handleContractPageClick(gotoPage)">GO</a>
          </div>
        </div>
      </div>
    </el-aside>
    <!-- 中间文件展示 -->
    <el-main ref="contrBody" class="main-box" :style="{ height: mainHeight + 'px' }">
      <div class="scroll-box" ref="scrollBox">
        <el-slider
          class="slider-bar"
          v-model="scaleValue"
          :step="5"
          :min="50"
          :max="200"
          show-input
        ></el-slider>
        <div
          class="wp-box"
          :style="`transform:scale(${scaleValue / 100});`"
          @mousedown.prevent="pageMousedown($event)"
          @mouseleave="pageLeave($event)"
        >
          <div ref="contrScro" class="contr-pages-scro" v-show="convertInfo.items > 0">
            <p class="con-pageindex">{{ currentData }}/{{ convertInfo.items }}</p>
            <img
              v-if="fileInfo.sign && convertInfo && convertInfo.items"
              class="imgInfo"
              :src="
                apiMethods.FileOperController.convertDetail_url(
                  fileInfo.sign || '',
                  fileInfo.ts || '',
                  fileInfo.fileType || '',
                  'png',
                  fileInfo.targetId || '',
                  currentData || '',
                  convertInfo.docHash || ''
                )
              "
              @loadstart="loadingStart()"
              @load="loadingClose()"
            />
            <!--         隐藏左右切换按钮-->
            <template v-if="false">
              <div v-if="currentData > 1" @click="handlePrePage()" class="pre">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div
                v-if="convertInfo.items > currentData"
                @click="handleNextPage()"
                class="next"
                :style="{ right: nextLeft }"
              >
                <i class="el-icon-arrow-right"></i>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- 去顶部去底部按钮-->
      <template v-if="convertInfo && convertInfo.items && convertInfo.items > 1">
        <span class="jumpFirst" @click="goPageAndFixed(1)">
          <img src="../../assets/images/btn-down.png" />
        </span>
        <span class="jumpLast" @click="goPageAndFixed(convertInfo.items)">
          <img src="../../assets/images/btn-down.png" />
        </span>
      </template>
    </el-main>
    <!-- 右侧功能按钮 -->
    <el-aside
      width="2.80rem"
      class="aside-right"
      ref="asideRight"
      :class="
        $route.query.isApprove && parseInt($route.query.isApprove) === 1
          ? 'approve-aside'
          : ''
      "
      v-show="!hideAside"
    >
      <div class="r-top" v-if="detailInfo.hideSignAllBtnFlag != 1 && !chapterData.sealImgPath">
        <!--合同更多的详情信息按钮-->
        <template v-if="signStatus !== -3 && signStatus !== -4">
          <!-- <div v-if="$store.getters.hasAuthUser && detailInfo.signStatus==1 && !isChild">
            <el-button @click="testify()" size="small" class="btn"><i class="f1"></i><i class="f1 on"></i>法律服务</el-button>
            <el-button size="small" class="btn"><i class="f1"></i><i class="f1 on"></i>出证服务</el-button>

            <div class="g-service-warp">4545454</div>
          </div>-->
          <!-- guoguo -->
          <certiServicepopover
            :type="1"
            listTyp="details"
            :param="viewInfo"
            v-if="
              $store.getters.hasAuthUser &&
              detailInfo.signStatus == 1 &&
              !isChild &&
              fromTo !== 'corpSignList'
            "
            class="g-certi-service"
            style="margin-bottom: 0.2rem"
          >
            <el-button size="small" class="btn">
              <i class="f1"></i>
              <i class="f1 on"></i>出证服务
            </el-button>
          </certiServicepopover>

          <p
            v-if="
              !$route.query.ftype &&
              !isChild &&
              detailInfo.hideSignAllBtnFlag != 1 &&
              detailInfo.hideSignlogFlag != 1
            "
          >
          <!-- sdetailsDialog = true -->
            <el-button @click="turnEivHand" size="small" class="btn">
              <i class="f2"></i>
              <i class="f2 on"></i>全证据链
            </el-button>
          </p>
          <p
            v-if="
              !$route.query.ftype &&
              !isChild &&
              detailInfo.hideSignAllBtnFlag != 1 &&
              detailInfo.hideSignlogFlag != 1
            "
          >
            <el-button @click="toPath('/applySign/toSignlog')" size="small" class="btn">
              <i class="f3"></i>
              <i class="f3 on"></i>签署详情
            </el-button>
          </p>
        </template>
        <p>
          <el-button v-show="notShowFlowInfo" @click="showInfo" size="small" class="btn">
            <i class="f4"></i>
            <i class="f4 on"></i>审批详情
          </el-button>
        </p>
      </div>
      <!--   审查工具（合同详情页不展示）   -->
      <!-- <div class="box-center" style="padding-top: 0;"
          v-show="detailInfo && detailInfo.hideSignAllBtnFlag !== 1 && detailInfo.createType !== 0">
        <div class="tl" style="margin: 20px 0 10px 20px">合同审查工具</div>
        <examination-tool :defaultTargetFile="detailInfo" />
      </div>-->
      <div class="r-bottom" v-if="detailInfo.hideSignAllBtnFlag != 1">
        <template v-if="!chapterData.sealImgPath">
          <p
            class="l-title"
            v-if="
              ![-3, -4].includes(signStatus) &&
              ((detailInfo.createType === 1 &&
                $store.getters.hasAuthUser &&
                detailInfo.signStatus == 1) ||
                ($store.getters.hasAuthUser &&
                  detailInfo.signStatus == 1 &&
                  !isChild))
            "
          >
            <i class="bd"></i>更多操作
          </p>
          <div class="c-content">
            <!--合同更多的详情信息按钮-->
            <template v-if="signStatus !== -3 && signStatus !== -4">
              <p
                v-show="
                  detailInfo.createType === 1 &&
                  $store.getters.hasAuthUser &&
                  detailInfo.signStatus == 1
                "
                @click="goPrint()"
              >
                <i class="b1"></i>
                <i class="b1 on"></i>防伪打印
                <span class="el-icon-d-arrow-right"></span>
              </p>
              <!--            <p-->
              <!--              v-if="-->
              <!--                $store.getters.hasAuthUser &&-->
              <!--                  detailInfo.signStatus == 1 &&-->
              <!--                  !isChild-->
              <!--              "-->
              <!--              @click="toShowPrompt()"-->
              <!--            >-->
              <!--              <i class="b2"></i><i class="b2 on"></i>设置提醒<span-->
              <!--                class="el-icon-d-arrow-right"-->
              <!--              ></span>-->
              <!--            </p>-->
              <p v-if="detailInfo.signStatus == 1" @click="openLYDialog()">
                <i class="b2"></i>
                <i class="b2 on"></i>上传履约文件
                <span class="el-icon-d-arrow-right"></span>
              </p>
              <p
                @click="
                  downloadFile({
                    targetId: fileInfo.targetId,
                    fileType: fileInfo.fileType,
                    sign: fileInfo.sign,
                    ts: fileInfo.ts,
                    fix: '.pdf',
                  })
                "
              >
                <i class="b3"></i>
                <i class="b3 on"></i>文件下载
                <span class="el-icon-d-arrow-right"></span>
              </p>
            </template>
          </div>
        </template>
        <div v-else style="text-align: center; margin-top: 20px">
          <img style="max-width: 80%" :src="sealImgPath" alt />
        </div>
        <!--合同更多的详情信息按钮-->
        <div class="bottom-btns" v-if="chapterData.selfApprove && !isInDingTalk">
          <p>
            <el-button @click="approveSubmitFn(1)" type="danger" size="small" class="btn">同意</el-button>
          </p>
          <p>
            <el-button @click="approveSubmitFn(2)" size="small" class="btn">拒绝</el-button>
          </p>
        </div>
      </div>
    </el-aside>

    <!--过程证据弹窗-->
    <process-evidence
      v-if="!$utils.isEmptyObj(viewInfo)"
      :show.sync="sdetailsDialog"
      :queryData="viewInfo"
    />

    <el-dialog
      :visible.sync="showChooseCert"
      title="法律服务"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="certList && certList.length > 0">
        <template v-for="(item, index) in certList">
          <div :key="index">
            <el-radio v-model="choosedCert" :label="index">
              {{
              item.idenName
              }}
            </el-radio>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="showCerti(certList[choosedCert])" size="small" type="danger">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showPrompt" title="设置提醒" width="550px" :close-on-click-modal="false">
      <div class="demo-dynamic">
        <div style="margin-bottom: 10px">注：系统将提示短信发送至接收手机</div>
        <el-form :model="promptFrm" ref="promptFrm" label-width="100px">
          <template v-for="(item, index) in promptFrm.promptList">
            <el-row :key="index">
              <el-col :span="11">
                <el-form-item
                  :prop="'promptList.' + index + '.mobile'"
                  label-width="0px"
                  :rules="[
                    {
                      validator: $validator.regex,
                      regex: /^1\d{10}$/,
                      message: '请输入正确手机号',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    v-model="item.mobile"
                    type="text"
                    :placeholder="'请输入手机号'"
                    :disabled="item.remote"
                    style="width: 220px; margin-right: 10px"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item
                  :prop="'promptList.' + index + '.promptTime'"
                  label-width="0px"
                  :rules="[
                    {
                      required: true,
                      message: '请选择提醒日期',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-date-picker
                    popper-class="date-popper-cls"
                    value-format="yyyy-MM-dd"
                    align="left"
                    :picker-options="promptTimePkOption"
                    v-model="item.promptTime"
                    type="date"
                    :disabled="item.remote"
                    :placeholder="'请选择提醒日期'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="promptFrm.promptList.length > 1 && !item.remote">
                <span
                  @click="promptFrm.promptList.splice(index, 1)"
                  style="font-size: 26px; color: #ec1c1c"
                >
                  <i class="el-icon-close"></i>
                </span>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center; margin-top: 40px">
        <el-button
          @click="promptFrm.promptList.push({ mobile: '', promptTime: '' })"
          size="small"
          type="danger"
          style="width: 120px"
        >添加</el-button>
        <el-button
          @click="promptOrder()"
          size="small"
          type="danger"
          style="width: 120px; margin-left: 10px"
        >确认提交</el-button>
      </div>
    </el-dialog>

    <!-- 审核详情 Dialog -->
    <el-dialog
      :visible.sync="dialogAuditDetailVisible"
      title="审批详情"
      width="800px"
      class="apprave-info"
    >
      <el-row>
        <el-col :span="24">
          <template v-if="!isInDingTalk">
            <audit-detail
              v-if="
                auditDetailInfo &&
                Object.keys(auditDetailInfo).length &&
                (auditDetailInfo.fileFlow.length ||
                  auditDetailInfo.sealFlow.length)
              "
              :auditor="auditDetailInfo"
            ></audit-detail>
            <el-empty v-else description="暂无数据"></el-empty>
          </template>
          <ding-audit-detail v-if="isInDingTalk" :auditor="auditDetailInfo" :applyInfo="detailInfo"></ding-audit-detail>
        </el-col>
      </el-row>
    </el-dialog>
    <!--  上传履约文件  -->
    <performance-file ref="performanceRef" :rowData="detailInfo" />
    <!-- 自定义loading -->
    <custLoading v-model="cloading"></custLoading>
  </el-container>
</template>

<script>
import performanceFile from "@/components/apply-list/performance-file";
import { ApiMethods, configUrl } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { loginOrRefresh } from "@/assets/js/http-serve/corp/common";
import AuditDetail from "../../components/auditDetail/new.vue";
import TemplateManage from "../console/template";
import CertiServicepopover from "@/components/apply-list/certiServicepopover";
import ProcessEvidence from "@/components/processEvidence/index";
import examinationTool from "@/components/signInfo/examination-tool";
import { isInDingTalk } from '../../assets/js/utils/ding-env';
import { fileOperShow } from "@/assets/js/http-serve/http-methods";
import dingAuditDetail from "@/components/auditDetail/dingNew.vue";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { mapGetters } from 'vuex'
import custLoading from "../../components/publicCom/custLoading/index.vue"

var qs = require("qs");

export default {
  components: {
    custLoading,
    TemplateManage,
    AuditDetail,
    dingAuditDetail,
    CertiServicepopover,
    ProcessEvidence,
    examinationTool,
    performanceFile
  },
  data () {
    return {
      cloading: false,
      switchInfo: { disableLoadingFlag: 1 },
      isInDingTalk,
      chapterData: {
        selfApprove: '',
      },
      sealImgPath: '',
      signStatus: undefined,
      // 审批详情 Dialog
      dialogAuditDetailVisible: false,
      auditDetailInfo: undefined,
      isChild: false,
      apiMethods: ApiMethods,
      navTab: 2,
      listHeight: "727",
      mainHeight: "1170",
      nextLeft: "0px",
      gotoPage: null,
      currentData: 1,
      sdetailsDialog: false,
      viewInfo: {},
      detailInfo: {},
      fileInfo: {},
      convertInfo: {},
      showChooseCert: false,
      certList: [],
      choosedCert: 0,
      showPrompt: false,
      promptFrm: { promptList: [{ mobile: "", promptTime: "" }] },
      // 审核人列表
      contractLoading: true,
      // 到期提醒时间输入限制必须大于今天
      promptTimePkOption: {
        disabledDate (time) {
          return time.getTime() < Date.now();
        }
      },
      printLoading: null,
      // 控制滚动加载上下页的开关，防止加载多次
      timerKg: true,
      // 合同缩放比例
      scaleValue: 100,
      // 拖动滚动变量
      pageX1: null,
      pageY1: null
    };
  },
  computed: {
    ...mapGetters(['currentAuthUser', 'allAuthUser',]),
    /** 不展示审批详情的逻辑 */
    notShowFlowInfo () {
      /**
       *
       * 6.以上均需区分来源 在saas中查看时  非saas来源的合同（目前钉钉）在存在审批流程时，提示利旧 让用户前往钉钉查看
       */
      const { auditDetailInfo, detailInfo: info, currentAuthUser: curr, allAuthUser: allU } = this;
      const accInfo = allU.accountInfoVO;
      //* 1.个人用户（个人身份下） 在待ta签的合同详情中 需要去除审批详情入口 userType 0 个人 userType 1 企业  【selfSign !=1 && signStatus == 0】
      const notShowPer = curr && curr.userType === 0 && (info && info.selfSign && info.selfSign != 1 && info.signStatus == 0);
      //* 2.登陆主体为企业主账户，在查看合同时 企业主账户发起的合同 签署方不包含自己及企业成员时 不显示审批详情入口
      // allAuthUser.accountInfoVO 登陆主体 userType 0 个人 userType 1 企业
      const accType = accInfo && accInfo.userType && accInfo.userType == 1
      //  企业主账户发起的合同
      const priAcc = accType && info && (!info.corpUserId && info.ebqUserId) && (info.ebqUserId === accInfo.userId) // (主账号发起)
      // 签署方不包含自己及企业成员时
      const notHaveMineOrCorp = accType && info && info.signInfos && info.signInfos.filter(
        item => ((item.emailMask && accInfo.emailMask) && (item.emailMask !== accInfo.emailMask)) || (item.corpId && (item.corpId !== accInfo.userId))
      ).length == 0
      const notShowAcc = priAcc && notHaveMineOrCorp
      //* 3.登陆主体为企业主账户，在查看合同时 企业主账户发起/签署的合同 签署方包含企业成员时 若有审批流程（用印审批）
      // 则显示审批详情入口 并显示审批流程记录  若无审批流程 则不显示审批详情入口
      //* 4.登陆主体为企业成员账户（个人），在查看合同时 成员账户发起/签署的合同 若存在审批流程（文件审批&用印审批）
      //  *  即显示审批详情入口 若不存在审批流程则不显示审批详情入口
      // * 5.登陆主体为企业成员账户（个人），在查看合同时 成员账户有权限查看的 其他成员的合同
      //  *  若存在审批流程（文件审批&用印审批） 即显示审批详情入口 若不存在审批流程则不显示审批详情入口
      // ! 能查看合同，说明一定有权限
      // 345结论相同不做判断条件，结论同show
      const show = auditDetailInfo &&
        Object.keys(auditDetailInfo).length &&
        (auditDetailInfo.fileFlow.length ||
          auditDetailInfo.sealFlow.length)
      return !notShowPer && !notShowAcc && show
    },
    userType () {
      return this.$store.getters.currentAuthUser.superFlag == 0 ||
        this.$store.getters.currentAuthUser.superFlag == 1
        ? 1
        : 0;
    },
    currentIsCorpUser () {
      // 当前是否是集团账户

      // let _currentAuthUser = this.$store.getters.currentAuthUser;
      // if(_currentAuthUser && _currentAuthUser.corpId){
      //   return true;
      // }
      if (
        (this.$store.getters.currentAuthUser || {}).hasOwnProperty("superFlag")
      ) {
        return true;
      }

      return false;
    },
    // 是否隐藏左右栏，只显示合同内容
    hideAside () {
      const isEmpty = Object.keys(this.detailInfo).length == 0
      const isHide = isEmpty ? true : this.$route.query.viewMode && +this.$route.query.viewMode === 1;
      return isHide
    }
  },
  created () {
    const v = sessionStorage.getItem("ISCHILD");
    if (v === "true") {
      this.isChild = true;
    }
  },
  async beforeMount () {
    // 没有用户数据时，刷新页面，重新获取
    if (
      !(
        this.$store.getters.currentAuthUser.userName ||
        this.$store.getters.currentAuthUser.name
      )
    ) {
      let refreshRes = await loginOrRefresh();
      if (!refreshRes.success) {
        this.reload();
      }
    }
  },
  mounted () {
    let { query } = this.$route;
    ApiMethods.ApplySignController.switchInfo(query).then(res => {
      if (res.success) this.switchInfo = res.data || {};
    }).finally(() => {
      this.fetchData();
      this.fromTo = query.fromTo;
      this.chapterData = query;
      this.listHeight = document.body.clientHeight - 210;
      this.mainHeight = document.body.clientHeight - 60;
      this.scrollTurnPage();
      this.handleClickAuditDetails();
      this.sealImgPathFn()
    })
  },
  methods: {
    /** 跳转到全证据链页面 */
    turnEivHand () {
      const routeData = this.$router.resolve({
        path: '/applySign/fullEvidenceChain',
        query: {...this.$route.query,...this.viewInfo}  // 传递当前页面的query参数
      });
      // 新开页面
      window.open(routeData.href, '_blank');
    },
    loadingStart () {
      const { disableLoadingFlag: flag } = this.switchInfo;
      flag ? this.cloading = true : this.printLoading = this.$loading({ lock: true })
    },
    loadingClose () {
      const { disableLoadingFlag: flag } = this.switchInfo;
      flag ? this.cloading = false : this.printLoading && this.printLoading.close()
    },
    sealImgPathFn () {
      if (this.chapterData && this.chapterData.sealImgPath) {
        let data = JSON.parse(this.chapterData.sealImgPath)
        this.sealImgPath = fileOperShow(data);
      }
    },
    //审批
    approveSubmitFn (type) {
      if (type === 1) {
        this.$confirm("是否同意用章申请？", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            ApiCorpMethods.CorpSealSignInfoController.approveSeal({
              partyId: this.chapterData.approveId,
              sign: this.chapterData.chapterSign,
              ts: this.chapterData.chapterTs,
              approveStatus: type
            }).then(res => {
              if (res.success) {
                this.chapterData.selfApprove = '';
                this.$message({
                  type: "success",
                  message: `操作成功`
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.code === '10103' ? '当前审批流程已失效' : res.description || '请重试'
                });
                this.$forceUpdate();
              }
            });
          })
          .catch(() => { });
      } else {
        this.$prompt("是否拒绝用章申请?", "拒绝理由", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: "",
          inputErrorMessage: "请输入内容"
        })
          .then(({ value }) => {
            let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
            if (regStr.test(value)) {
              this.$message({
                type: "error",
                message: `请输入有效内容`
              });
            } else {
              ApiCorpMethods.CorpSealSignInfoController.approveSeal({
                partyId: this.chapterData.approveId,
                sign: this.chapterData.chapterSign,
                ts: this.chapterData.chapterTs,
                reason: value,
                approveStatus: type
              }).then(res => {
                if (res.success) {
                  // this.getSealList();
                  this.chapterData.selfApprove = '';
                  this.$message({
                    type: "success",
                    message: `操作成功`
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.code === '10103' ? '当前审批流程已失效' : res.description || '请重试'
                  });
                }
              });
            }
          })
          .catch(() => { });
      }
    },
    openLYDialog: function () {
      this.$refs.performanceRef.openLYDialog();
    },
    getId: function (id) {
      if (!id) return "";
      let res = id;
      for (let i = 0; i < 6 - id.toString().length; i++) {
        res = "0" + res;
      }
      return res;
    },
    showInfo: function () {
      this.dialogAuditDetailVisible = true;
      this.handleClickAuditDetails();
    },
    // 审核详情
    handleClickAuditDetails: function () {
      let { signNo, applyNo } = this.$route.query;
      if (!signNo && !applyNo) return false;
      let params = {
        signNo: signNo ? signNo : "",
        applyNo: applyNo ? applyNo : ""
      };
      ApiCorpMethods.CorpAuditContractController.flowInstV2(params)
        .then(res => {
          if (res.code === "0") {
            if (isInDingTalk) { this.dingtalkFlowInfo() }
            if (!isInDingTalk) this.auditDetailInfo = res.data;
          } else {
            this.auditDetailInfo = undefined;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.auditDetailInfo = undefined;
          this.$message.error(error.description || "获取审批人列表失败");
        });
    },
    /** 钉钉审批详情 */
    dingtalkFlowInfo () {
      // 查询钉钉审批详情流程
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        { signNo, applyNo } = this.$route.query,
        _this = this;
      const _applyNo = applyNo ? applyNo : this.detailInfo.applyNo
      const data = { corpId, dingTalkUserId, applyNo: _applyNo }
      dingtalkApi.v2TaskList(data).then(res => {
        if (!res.success) return isInDingTalk ? false : this.$message.error(`文件审批详情：${res.description}`)
        _this.auditDetailInfo = {
          fileFlow: [res.data],
          sealFlow: []
        }
      })
    },
    // 输入input合同跳页
    handleContractPageClick: function (page) {
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.convertInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed: function (page) {
      this.currentData = parseFloat(page);
      this.toCurrentPage(page);
      this.$refs["scrollBox"].scrollTop = 0;
    },
    toPath: function (url) {
      let { href } = this.$router.resolve({ path: url, query: this.viewInfo });
      if (isInDingTalk) {
        location.href = window.location.origin + href
      } else {
        window.open(window.location.origin + href, "_blank");
      }
    },
    goPrint: function () {
      this.loadingStart();
      ApiMethods.SignPrintController.getSign(this.$route.query)
        .then(res1 => {
          if (!res1.success)
            return this.$message.error(res1.description || "操作失败");
          ApiMethods.SignPrintController.printStatus(
            Object.assign(res1.data, { userType: this.userType })
          )
            .then(res2 => {
              if (!res2.success)
                return this.$message.error(res2.description || "操作失败");
              if (res2.data.needPay) {
                this.$confirm(
                  `需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`,
                  "支付提示",
                  {
                    showConfirmButton: true,
                    showCancelButton: true,
                    type: "info"
                  }
                ).then(() => {
                  ApiMethods.SignPrintController.order(
                    Object.assign(res1.data, {
                      userType: this.userType,
                      pay: 1
                    })
                  )
                    .then(res => {
                      if (+res.code === 10806) {
                        this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                        return;
                      }
                      if (+res.code === 0) {
                        let { href } = this.$router.resolve({
                          path: "/applySign/contractPrint",
                          query: this.$route.query
                        });
                        location.href = window.location.origin + href;
                        return;
                      }
                      this.$message.error(res.description || "支付失败");
                    })
                    .finally(() => this.loadingClose());
                });
              } else {
                let { href } = this.$router.resolve({
                  path: "/applySign/contractPrint",
                  query: this.$route.query
                });
                location.href = window.location.origin + href;
              }
            })
            .finally(() => loadingClose());
        })
        .finally(() => loadingClose());
    },
    showCerti: function (data) {
      this.$router.push({ path: "/certi/certiPage", query: data });
    },
    testify: function () {
      var _this = this;
      ApiMethods.ApplySignController.certi(_this.viewInfo).then(result => {
        if (result.success) {
          _this.showCerti(result.data);
        } else {
          ApiMethods.ApplySignController.certiList(_this.viewInfo).then(
            _result => {
              if (!_result.success) {
                return _this.$message.error(_result.description || "操作失败");
              } else {
                if (_result.data.length === 1)
                  return _this.showCerti(_result.data[0]);
                _this.certList = _result.data;
                _this.showChooseCert = true;
              }
            }
          );
        }
      });
    },
    toShowPrompt: function () {
      var _this = this;
      var param = {
        signNo: _this.$route.query.signNo,
        applyNo: _this.$route.query.applyNo
      };
      ApiMethods.SendSms4SignController.promptList(param).then(result => {
        if (result.success) {
          if (result.data && result.data.length > 0) {
            _this.promptFrm.promptList = result.data.map(i => {
              i.remote = true;
              return i;
            });
          }
          this.showPrompt = true;
        } else {
          _this.$message.error(result.description || this.$tip);
        }
      });
    },
    promptOrder: function () {
      var _this = this;
      if (_this.promptFrm.promptList.length < 1) {
        return _this.$message.error("提交数据不能为空");
      }
      _this.$refs.promptFrm.validate(valid => {
        if (valid) {
          // var newWindow = window.open();
          var param = {
            signNo: _this.$route.query.signNo,
            applyNo: _this.$route.query.applyNo
          };
          param.promptJson = JSON.stringify(
            _this.promptFrm.promptList.filter(i => !i.remote)
          );
          param.returnURL = window.location.href;
          ApiMethods.SendSms4SignController.promptOrder(param).then(result => {
            if (!result.success)
              return _this.$message.error(result.description || "操作失败");
            if (result.data.recharge) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            } else {
              this.$confirm(
                `本次提醒需消耗${result.data.point}积分`,
                "支付提示",
                {
                  showConfirmButton: true,
                  showCancelButton: true,
                  type: "info"
                }
              ).then(() => {
                ApiMethods.SendSms4SignController.promptOrder(
                  Object.assign(param, { pay: 1 })
                ).then(res => {
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  if (+res.code === 0) {
                    this.toShowPrompt();
                    return this.$message.success("提交成功");
                  }
                  this.$message.error(res.description || "支付失败");
                });
              });
            }
          });
        }
      });
    },
    loadData: function () {
      var _this = this;
      ApiMethods.ApplySignController.info(_this.viewInfo).then(result => {
        if (!result.success) {
          return _this.$message.error(result.description || "初始化数据失败！");
        }
        if (result.data.signStatus === -6) {
          // 合同已过期，提示失效
          return this.$message.error("文件已过期");
        } else if (result.data.dealType === 6) {
          // hash只保全
          return this.$message.error("暂不支持Hash保全类型的文件");
        } else if (!result.data.fileInfo) {
          // 没有fileInfo（合同信息不存在）
          return this.$message.error("要查看的合同文件内容已不存在");
        }
        _this.detailInfo = result.data;
        // 审核状态 -3 审核中
        this.signStatus = result.data.signStatus;
        _this.fileInfo = result.data.fileInfo;
        // 判断是否国际版发起的合同，如果不是就提示需要去国内版本签署(当合同applyNo以APLO开头时，说明是国际版发起的合同)
        if((_this.detailInfo.applyNo && _this.detailInfo.applyNo.startsWith('APLO')) && this.signStatus == 0){
          this.$message.warning('国际版发起的文件请前往 FairSigning 操作!');
        }
        // 极简模式
        const hideBtn = _this.detailInfo && _this.detailInfo.ifHideBottom == 1;
        const hideAllBtn =
          _this.detailInfo && _this.detailInfo.hideSignAllBtnFlag == 1;
        if (hideBtn || hideAllBtn) {
          try {
            document.querySelector("header.el-header").style.display = "none";
            let headerY = document.querySelector(".y-header"),
              rightSiad = document.querySelector(".aside-right");
            (!headerY || headerY.clientHeight == 0) &&
              (_this.mainHeight = _this.mainHeight + 60);
            headerY.style.height = "0px";
            if (hideAllBtn) rightSiad.style.width = "0px";
          } catch (e) { }
        } else {
          try {
            document.querySelector("header.el-header").style.display = "block";
          } catch (e) { }
        }
        /*{
        "applyNo":"","contractName":"","signStatus":1,"createTime":"","signTime":"","createType":1,"ebqUserName":"陈辉",
        "signInfos":[{"signNo":"","fullName":"1222","identityCardMask":"","identityType":1,"mobileMask":"","signStatus":1,"signTime":"","identityLevel":2}],
        "fileInfo":{"targetId":"","fileType":3,"ts":1533039428005,"sign":""}
        }*/
        ApiMethods.FileOperController.convertInfoNoFile(
          result.data.fileInfo
        ).then(result => {
          //"data":{"stype":"isimgs","items":13,"docHash":"Zcd7luVpZPT31aXvBIwiUNVt764UwL0dpphB0-WanJWRBQuowoY_LO2hRnSDPapTavj-LG-Z6t0CXv772aj2-Q"}
          if (!result.success) {
            return _this.$message.error(result.description || "文件转换错误");
          }
          _this.convertInfo = result.data;
          window.setTimeout(function () {
            const vi = _this.$refs.contrScro ? _this.$refs.contrScro.offsetWidth : '';
            const vm = _this.$refs.contrBody ? _this.$refs.contrBody.$el.offsetWidth : '';
            const asideRight = _this.$refs.asideRight ? _this.$refs.asideRight.$el.clientWidth : '';
            if (vi < vm) {
              _this.nextLeft = (vm - vi) / 2 + +5 + asideRight + "px";
            } else {
              _this.nextLeft = asideRight + "px";
            }
            //contrBody
          }, 1000);
        });
      });
    },
    async fetchData () {
      var _this = this;
      if (_this.$route.query.ts && _this.$route.query.sign) {
        _this.viewInfo = _this.$route.query;
        this.loadData();
      } else {
        //没有签名参数
        var param = {
          signNo: _this.$route.query.signNo,
          applyNo: _this.$route.query.applyNo
        };
        let viewUrlRes = "";
        if (!this.currentIsCorpUser) {
          // 个人或者企业
          viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(param);
        } else {
          // 集团用户在工作台调用
          viewUrlRes = await ApiCorpMethods.ContractController.corpViewUrl(
            param
          );
        }
        if (!viewUrlRes.success) {
          return _this.$message.error(
            viewUrlRes.description || "初始化数据失败."
          );
        }

        _this.viewInfo = viewUrlRes.data;
        this.loadData();
      }
    },
    async downloadFile (param) {
      const { applyNo, signNo } = this.$route.query
      if (applyNo) param.applyNo = applyNo
      if (signNo) param.signNo = signNo
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    // ******滚动翻页******start
    // 上一页 点击方法
    // 定位到当前展示页,滚动翻页才定位
    toCurrentPage: function (val) {
      let dom = document.querySelectorAll(".list-pages .list")[val - 1];
      if (dom) {
        let dom2 = document.querySelectorAll(".list-pages")[0];
        dom2.scrollTop = dom.offsetTop - 20;
      }
    },
    handlePrePage: function (bool) {
      if (this.currentData > 1) {
        this.currentData = --this.currentData;
        this.$refs["scrollBox"].scrollTop = this.$refs[
          "scrollBox"
        ].scrollHeight;
        bool && this.toCurrentPage(this.currentData);
      }
    },
    // 下一页合同 点击方法
    handleNextPage: function (bool) {
      if (this.convertInfo.items > this.currentData) {
        this.currentData = ++this.currentData;
        this.$refs["scrollBox"].scrollTop = 0;
        bool && this.toCurrentPage(this.currentData);
      }
    },
    // 上滚动
    scrollUp: function (dom) {
      if (dom.scrollTop > 0) return;
      if (!this.timerKg) return;
      this.timerKg = false;
      setTimeout(() => {
        this.handlePrePage(true);
        this.timerKg = true;
      }, 100);
    },
    // 下滚动
    scrollDown: function (dom) {
      if (Math.ceil(dom.clientHeight + dom.scrollTop) < dom.scrollHeight) return;
      if (!this.timerKg) return;
      this.timerKg = false;
      setTimeout(() => {
        this.handleNextPage(true);
        this.timerKg = true;
      }, 100);
    },
    // 鼠标滚动翻页
    scrollTurnPage: function () {
      let domS = this.$refs["scrollBox"];
      let scrollFunc = e => {
        e = e || window.event;
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            //当滑轮向上滚动时
            // alert("滑轮向上滚动");
            this.scrollUp(domS);
          }
          if (e.wheelDelta < 0) {
            //当滑轮向下滚动时
            // alert("滑轮向下滚动");
            this.scrollDown(domS);
          }
        } else if (e.detail) {
          //Firefox滑轮事件
          if (e.detail > 0) {
            // 下
            this.scrollDown(domS);
          }
          if (e.detail < 0) {
            // 上
            this.scrollUp(domS);
          }
        }
        // 小地图时禁止盒子滚动引起外部滚动条滚动
        if (this.showSmallBox) {
          if (e.preventDefault) {
            // Firefox
            e.preventDefault();
            e.stopPropagation();
          } else {
            // IE
            e.cancelBubble = true;
            e.returnValue = false;
          }
        }
      };
      //给页面绑定滑轮滚动事件
      if (domS.addEventListener) {
        //firefox
        domS.addEventListener("DOMMouseScroll", scrollFunc, false);
      }
      //滚动滑轮触发scrollFunc方法  //ie 谷歌
      domS.onmousewheel = domS.onwheel = scrollFunc;
    },
    // ******滚动翻页******end
    // .............滑动页面 start..................
    // 页面缩放-真实值计算为实际值
    scaleToVal: function (val) {
      return parseFloat(val) * (this.scaleValue / 100);
    },
    pageMousedown: function (el) {
      el.preventDefault();
      let domScroll = document.getElementsByClassName("scroll-box")[0];
      // console.log([domScroll], 66666)
      // console.log(domScroll.clientWidth,this.scaleToVal(el.target.clientWidth), 77777)
      this.pageX1 = el.pageX;
      this.pageY1 = el.pageY;
      // if(el.target.tagName!='IMG' && el.target.className !='wp-box'){
      //   return
      // }
      // if(parseInt(domScroll.clientWidth) >= this.scaleToVal(el.target.clientWidth)) return;
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        el.target.style.cursor = "pointer";
      } else {
        el.target.style.cursor = "grab";
      }
      domScroll.addEventListener("mousemove", this.pageMousemove, false);
      domScroll.addEventListener("mouseup", this.pageMouseStop, false);
    },
    pageMousemove: function (e) {
      let max = this.scaleToVal(200); // 限制单次最大移动距离
      let domScroll = document.getElementsByClassName("scroll-box")[0];
      let x1 = this.pageX1 - e.clientX;
      x1 = Math.abs(x1) > max ? (x1 >= 0 ? max : -max) : x1;
      let y1 = this.pageY1 - e.clientY;
      y1 = Math.abs(y1) > max ? (y1 >= 0 ? max : -max) : y1;
      domScroll.scrollLeft = domScroll.scrollLeft + Math.ceil(x1 / 30);
      domScroll.scrollTop = domScroll.scrollTop + Math.ceil(y1 / 30);
    },
    pageMouseStop: function (el) {
      let domScroll = document.getElementsByClassName("scroll-box")[0];
      let imgDom = document.querySelector(".scroll-box .imgInfo");
      imgDom && (imgDom.style.cursor = "default");
      domScroll.removeEventListener("mousemove", this.pageMousemove, false);
      domScroll.removeEventListener("mouseup", this.pageMouseStop, false);
    },
    pageLeave: function (el) {
      this.pageMouseStop();
    }
    // .............滑动页面 end..................
  },
  head: {
    title: "文件详情"
  },
  name: "toDetailAnony",
  layout: "fullpage"
};
</script>

<style lang="less" scoped>
.bottom-btns {
  padding: 20px;
}
.apprave-info /deep/ .el-dialog__body {
  height: 65vh;
  overflow-y: scroll;
  background-color: #e7e7e7;
}
.g-certi-service {
  margin-bottom: 0.2rem;
  display: block;
}
.demo-dynamic {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.sdetails-dialog {
  .sdetails {
    height: 450px;
    overflow-x: hidden;
    margin: -20px -20px -10px;
    padding: 20px 20px 10px;

    .sdetails-item {
      padding: 20px 0;
      border-bottom: 1px solid #e7e7e7;
    }

    b {
      color: #009899;
    }

    h5 {
      margin: 0;
      color: #009899;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 6px;
    }

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      word-break: break-all;
    }
  }
}
@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-right {
  /*padding: 20px 20px 0px 20px;*/
  background: #ffffff;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  margin-left: @mg;

  &.approve-aside {
    padding: 0;
    padding-top: 0.2rem;
    text-align: center;

    .btn {
      width: 80%;
      margin: 0;
      margin-bottom: 0.1rem;
    }
  }

  .btn {
    width: 100%;
    /*margin-bottom: 20px;*/
  }

  .r-top {
    padding: 0.4rem 0.27rem 0.2rem 0.27rem;
    // box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 2;
    margin-bottom: 0.5rem;
    button {
      border: 1px solid rgba(236, 28, 28, 1);
      border-radius: 0.04rem;
      line-height: 0.35rem;
      padding: 0;
      font-size: 14px;
      color: #ec1c1c;
      &:hover {
        background: #ec1c1c;
        color: #ffffff;
        i {
          display: none;
        }
        .on {
          display: inline-block;
        }
      }

      i {
        vertical-align: middle;
        margin-right: 11px;
        display: inline-block;
        width: 12px;
        height: 12px;
        &.on {
          display: none;
        }
      }
    }
  }

  .r-bottom {
    .l-title {
      border-bottom: 1px solid #f2f2f2;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      text-align: left;
      padding: 0.03rem 0;
      margin-bottom: 0;
      .bd {
        width: 0.05rem;
        height: 0.15rem;
        background: rgba(38, 38, 38, 1);
        opacity: 1;
        border-radius: 1rem;
        display: inline-block;
        margin-right: 0.1rem;
      }
    }
    .c-content {
      padding: 0.3rem;
      p {
        cursor: pointer;
        color: rgba(0, 0, 0, 0.85);
        &:hover {
          color: #ec1c1c;
          i {
            display: none;
          }
          .on {
            display: inline-block;
          }
        }
        > i {
          vertical-align: middle;
          margin-right: 0.1rem;
          display: inline-block;
          width: 0.15rem;
          height: 0.15rem;
          &.on {
            display: none;
          }
        }
        > span {
          float: right;
        }
      }
    }
  }
  p {
    margin-bottom: 0.2rem;
  }
  .f1 {
    background: url("../../assets/images/icon_f1_on.png");
    background-size: 100% 100%;
  }
  .f1.on {
    background: url("../../assets/images/icon_f1.png");
    background-size: 100% 100%;
  }
  .f2 {
    background: url("../../assets/images/icon_f2_on.png");
    background-size: 100% 100%;
  }
  .f2.on {
    background: url("../../assets/images/icon_f2.png");
    background-size: 100% 100%;
  }
  .f3 {
    background: url("../../assets/images/icon_f3_on.png");
    background-size: 100% 100%;
  }
  .f3.on {
    background: url("../../assets/images/icon_f3.png");
    background-size: 100% 100%;
  }
  .f4 {
    background: url("../../assets/images/icon_f4_on.png");
    background-size: 100% 100%;
  }
  .f4.on {
    background: url("../../assets/images/icon_f4.png");
    background-size: 100% 100%;
  }
  .b1 {
    background: url("../../assets/images/icon_b1.png");
    background-size: 100% 100%;
  }
  .b1.on {
    background: url("../../assets/images/icon_b1_on.png");
    background-size: 100% 100%;
  }
  .b2 {
    background: url("../../assets/images/icon_b2.png");
    background-size: 100% 100%;
  }
  .b2.on {
    background: url("../../assets/images/icon_b2_on.png");
    background-size: 100% 100%;
  }
  .b3 {
    background: url("../../assets/images/icon_b3.png");
    background-size: 100% 100%;
  }
  .b3.on {
    background: url("../../assets/images/icon_b3_on.png");
    background-size: 100% 100%;
  }
}

.main-box {
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  /*display: table-cell;*/
  display: block;
  padding: 0;
  /*background: #ffffff;*/
  text-align: center;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .con-pageindex {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 16px 0;
    z-index: 1000;
  }

  .wp-box {
    transform-origin: 0 0;
    /*left: 0;*/
    /*top: 0;*/
    /*position: absolute;*/
  }
  @media (min-width: 1921px) {
    .contr-pages-scro > img {
      width: auto;
      height: auto;
    }
  }
  @media (max-width: 1920px) {
    // 当屏幕宽度在 768px 到 1024px 之间时应用的样式
    .contr-pages-scro > img {
      width: 100%;
      height: auto;
    }
  }
  .contr-pages-scro {
    transform-origin: 0 0;
    position: relative;
    display: inline-block;
    top: 0;
    background: #ffffff;
    /*width: 100%;*/
    /*max-width: 1000px;*/

    .next {
      position: fixed;
      top: 40%;
      width: 40px;
      padding: 20px 0;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      z-index: 1020;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      i {
        color: #ffffff;
        font-size: 40px;
      }
    }

    .pre {
      position: fixed;
      top: 40%;
      width: 40px;
      padding: 20px 0;
      background: rgba(0, 0, 0, 0.3);
      cursor: pointer;
      z-index: 1020;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      i {
        color: #ffffff;
        font-size: 40px;
      }
    }
  }

  .scroll-box {
    height: 100%;
    width: 100%;
    /*padding-right: 10%;*/
    box-sizing: border-box;
    overflow-y: auto;
    /*overflow-x: hidden;*/
  }
}

.aside-left {
  background: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 1;
  margin-right: @mg;

  .page-con {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 0.3rem;
  }
  .list-pages::-webkit-scrollbar {
    width: 0;
  }
  .list-pages {
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 0.2rem;
    padding-left: 0.26rem;
    padding-right: 0.26rem;
    background: #fff;
    color: #323232;
    position: relative;

    div.active {
      img {
        border-color: #ec1c1c;
      }
      .p-index {
        background-color: #ec1c1c;
      }
    }

    div {
      position: relative;
      box-sizing: border-box;
      margin-bottom: 0.2rem;
      cursor: pointer;

      .p-index {
        position: absolute;
        box-sizing: border-box;
        bottom: 0px;
        right: 0;
        display: block;
        width: 0.4rem;
        height: 0.3rem;
        line-height: 0.3rem;
        color: #fff;
        background-color: #e3e3e3;
        text-align: center;
        border-radius: 0.06rem 0px 0px 0px;
      }

      img {
        max-height: 3rem !important;
        box-sizing: border-box;
        width: 100%;
        /*margin-bottom: 10px;*/
        border: 0.02rem solid #e3e3e3;
      }
    }
  }
}

.sec-content {
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  z-index: 2;
  padding: 0 0.15rem;
  box-shadow: 0px -0.03rem 0.06rem rgba(0, 0, 0, 0.09);

  p {
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 0.16rem;
    font-size: 14px;
    word-break: break-word;
  }

  label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }

  .nav-item {
    /*width: 180px;*/
    padding-top: 0.15rem;
    border-bottom: 1px solid #ebebeb;
    font-size: 12px;
    box-sizing: border-box;
  }

  .wnj {
    p {
      color: rgba(0, 0, 0, 0.85);
    }

    label {
      color: rgba(0, 0, 0, 0.45);
    }
  }
}

.nav-tab {
  margin: 0;
  border-bottom: 1px solid #e4e4e4;
  text-align: center;

  .nav-item {
    display: inline-block;
    box-sizing: border-box;
    padding: 0.06rem;
    min-width: 0.72rem;
    background: #fff;
    border-top-left-radius: 0.04rem;
    border-top-right-radius: 0.04rem;
    border: 1px solid #e4e4e4;
    border-bottom: 0;
    font-size: 0.12rem;
    cursor: pointer;
    text-align: center;
    color: #666666;
  }

  .nav-item.active {
    color: #fff;
    background-color: #999999;
    border-color: #999999;
  }
}

.to-deatil_anony {
  margin: -20px;
  justify-content: space-between;

  .page-input {
    width: 150px;
    margin: 10px 15px 20px 15px;
    position: relative;

    .btn {
      padding: 0;
      width: 50px;
      margin: 0 -20px;
    }

    .input {
      display: inline-block;
      box-sizing: border-box;
      width: 100px;
      height: 34px;
      font-size: 13px;
      padding: 0 10px;
      line-height: 1.42857143;
      color: #999999;
      background-color: #ffffff;
      background-image: none;
      border: 1px solid #cccccc;
      border-radius: 2px;
    }
  }
}

// 跳转页面
.go-Page {
  // height:60px;
  // line-height:60px;
  padding: 0.3rem 0;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 5;
  background-color: #ffffff;
  border-top: 1px solid #f2f2f2;
  > div {
    display: inline-block;

    > div {
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      line-height: 28px;
    }
  }

  .bd {
    height: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(183, 183, 183, 1);
    border-style: solid none solid solid;
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding-right: 0.05rem;
    border-radius: 0.04rem 0 0 0.04rem;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    width: 0.6rem;
    border-radius: 0px 0.04rem 0.04rem 0px;
    display: block;
    background: #999999;
    border: 1px solid #999999;
    color: rgba(255, 255, 255, 1);
    font-family: PingFang SC;
  }

  /deep/ .el-input {
    /*width: 75px;*/
    width: 1.2rem;
    height: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 0.14rem;
    border: none;
    padding: 0 0 0 0.05rem;
    height: 100%;
    line-height: inherit;
  }
}

.slider-bar {
  position: fixed;
  z-index: 1;
  top: 68px;
  left: 3rem;
  width: 300px;
}
.my-el-header {
  display: none;
}
/deep/ .el-slider {
  .el-slider__bar {
    background-color: rgba(236, 28, 28, 1);
  }

  .el-slider__button {
    border: 2px solid rgba(236, 28, 28, 1);
  }
  .el-slider__runway:hover {
    .el-slider__bar {
      transition: all ease 0.2s;
      background-color: rgba(236, 28, 28, 1);
    }

    .el-slider__button {
      transition: all ease 0.2s;
      border: 2px solid rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/applySign/toDetailAnony.vue